// src/pages/MeetChefsCity.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ChefGrid from "../components/ChefGrid";
import "./meet-chefs.css"; // ← bring back the grid styles

// Cloudflare Images URLs for demo chefs
const DEMO_CHEFS = [
  { name: "Marques", img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/31c41e57-f5fa-40b6-16e6-f26abdd7c700/public" }, // chef1
  { name: "Emilio",  img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/1011e93f-269d-47da-5c97-b53bce4eb600/public" }, // chef2
  { name: "Elena",   img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/b823c9c5-a3bf-42f0-ded1-240a4b8f4500/public" }, // chef3
  { name: "Aiko",    img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/6bf5fd8a-c9ea-47e8-a965-15c284ff5a00/public" }, // chef4
  { name: "Elena",   img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/c6d67a3c-84d9-42ef-4676-031fd4233e00/public" }, // chef5
  { name: "Sofia",   img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/58756b2a-9dc0-4097-9fb0-c3217f80dd00/public" }, // chef6
  { name: "Luca",    img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/b459f40c-612e-478e-2210-e2ec4e600400/public" }, // chef7 - fixed broken image (using placeholder)
  { name: "Priya",   img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/b2e3b402-3660-4e3e-23aa-cfb693b16d00/public" }, // chef8
  { name: "Omar",    img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/dc110e42-bc52-48d2-a47b-cc46b5ccd700/public" }, // chef9
  { name: "Yuki",    img: "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/73c31bd5-c860-44e3-4827-133779e10a00/public" }, // chef10
];

// Placeholder image URL
const PLACEHOLDER = "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/chef2table_placeholder/public";

// Placeholder image from Cloudflare Images
const PLACEHOLDER_URL = "https://imagedelivery.net/YQhisQdXT8651Bk9Z7c9KQ/b459f40c-612e-478e-2210-e2ec4e600400/public";

// Individual chef image constants - 10 distinct, gender-balanced chef images from Unsplash
const CHEF1 = "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop&crop=face"; // Female chef
const CHEF2 = "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=400&h=400&fit=crop&crop=face"; // Male chef
const CHEF3 = "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=400&h=400&fit=crop&crop=face"; // Female chef
const CHEF4 = "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face"; // Male chef
const CHEF5 = "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face"; // Female chef
const CHEF6 = "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face"; // Male chef
const CHEF7 = "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face"; // Female chef
const CHEF8 = "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face"; // Male chef
const CHEF9 = "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=face"; // Female chef
const CHEF10 = "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop&crop=face"; // Male chef

// Cities (without LA, SF, Seattle)
const CITIES = [
  { slug: "toronto",     label: "Toronto" },
  { slug: "new-york",    label: "New York" },
  { slug: "boston",      label: "Boston" },
  { slug: "chicago",     label: "Chicago" },
  { slug: "new-orleans", label: "New Orleans" },
  { slug: "miami",       label: "Miami" },
  { slug: "austin",      label: "Austin" },
];

// Random 5-per-city from the demo chefs (with exactly 1 placeholder per city)
function pickFiveForCity(citySlug) {
  // Create a shuffled copy of demo chefs
  const shuffledChefs = [...DEMO_CHEFS].sort(() => Math.random() - 0.5);
  
  // Pick 4 random chefs
  const selectedChefs = shuffledChefs.slice(0, 4);
  
  // Add placeholder at random position
  const placeholderPosition = Math.floor(Math.random() * 5);
  
  const five = [];
  let chefIndex = 0;
  
  for (let i = 0; i < 5; i++) {
    if (i === placeholderPosition) {
      // Insert placeholder chef at this position
      five.push({
        name: "Chef2Table",
        img: PLACEHOLDER_URL,
        isPlaceholder: true
      });
    } else {
      // Insert regular chef
      let chef = selectedChefs[chefIndex];
      
      // Special case: Replace Elena with Boodgy in Chicago
      if (citySlug === "chicago" && chef.name === "Elena") {
        chef = { ...chef, name: "Boodgy" };
      }
      
      five.push(chef);
      chefIndex++;
    }
  }
  
  return five;
}

export default function MeetChefsCity() {
  const { city: citySlugParam } = useParams();
  const citySlug  = citySlugParam || "toronto";
  const cityLabel = CITIES.find(c => c.slug === citySlug)?.label || citySlug;

  const [chefs, setChefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [debugInfo, setDebugInfo] = useState(null);

  useEffect(() => {
    const loadChefs = async () => {
      try {
        // Fetch real chefs from API
        console.log(`[${citySlug}] Fetching chefs from API...`);
        const apiUrl = `/api/chefs?city=${encodeURIComponent(citySlug)}&status=approved,live&limit=10`;
        console.log(`[${citySlug}] API URL:`, apiUrl);
        console.log(`[${citySlug}] Full URL:`, window.location.origin + apiUrl);
        
        const response = await fetch(apiUrl);
        console.log(`[${citySlug}] API Response status:`, response.status, response.statusText);
        console.log(`[${citySlug}] API Response headers:`, Object.fromEntries(response.headers.entries()));
        
        let realChefs = [];
        
        if (response.ok) {
          const responseText = await response.text();
          console.log(`[${citySlug}] Raw response text:`, responseText);
          
          let data;
          try {
            data = JSON.parse(responseText);
            console.log(`[${citySlug}] Parsed JSON:`, data);
          } catch (parseError) {
            console.error(`[${citySlug}] JSON Parse Error:`, parseError);
            console.error(`[${citySlug}] Response text:`, responseText);
            throw parseError;
          }
          
          realChefs = (data.results || []).map(chef => ({
            ...chef,
            data_source: 'real',
            // Ensure consistent image field names
            photoUrl: chef.photo_url,
            imageUrl: chef.photo_url,
            image: chef.photo_url,
            img: chef.photo_url,
          }));
          console.log(`[${citySlug}] Real chefs loaded:`, realChefs.map(c => ({ name: c.name, photo_url: c.photo_url })));
        } else {
          console.error(`[${citySlug}] API Error:`, response.status, response.statusText);
          const errorText = await response.text();
          console.error(`[${citySlug}] API Error body:`, errorText);
        }

        // Get demo chefs for this city
        const demoChefs = pickFiveForCity(citySlug).map((c, i) => {
          const img = c.img || PLACEHOLDER;
          const displayName = c.isPlaceholder ? c.name : `Chef ${c.name}`;

          return {
            id: `${citySlug}-demo-${i}`,
            name: displayName,
            city: cityLabel,
            data_source: 'demo',
            photo_url: img || PLACEHOLDER,
            photoUrl: img || PLACEHOLDER,
            imageUrl: img || PLACEHOLDER,
            image: img || PLACEHOLDER,
            img: img || PLACEHOLDER,
            isPlaceholder: c.isPlaceholder,
          };
        });

        // Fix ALL real chefs that have null/placeholder images by giving them demo images
        const realChefsWithImages = realChefs.map((chef, index) => {
          if (!chef.photo_url || chef.photo_url === PLACEHOLDER) {
            // Assign different demo images to different chefs to avoid duplicates
            // Use chef name hash to ensure consistent but unique image assignment
            const demoImages = [CHEF1, CHEF2, CHEF3, CHEF4, CHEF5, CHEF6, CHEF7, CHEF8, CHEF9, CHEF10];
            
            // Create a simple hash from chef name to ensure consistent image assignment
            let hash = 0;
            const chefName = chef.name || `chef-${index}`;
            for (let i = 0; i < chefName.length; i++) {
              hash = (hash * 31 + chefName.charCodeAt(i)) >>> 0;
            }
            const demoImage = demoImages[hash % demoImages.length];
            
            return {
              ...chef,
              photo_url: demoImage,
              photoUrl: demoImage,
              imageUrl: demoImage,
              image: demoImage,
              img: demoImage,
            };
          }
          return chef;
        });

        // Mix real and demo chefs - prioritize real chefs, fill with demo if needed
        const mixedChefs = [...realChefsWithImages];
        
        // If we have fewer than 5 real chefs, add demo chefs to fill up to 5 total
        if (mixedChefs.length < 5) {
          const needed = 5 - mixedChefs.length;
          const demoToAdd = demoChefs.slice(0, needed);
          mixedChefs.push(...demoToAdd);
        }

        // Ensure we have exactly 5 chefs total
        const finalChefs = mixedChefs.slice(0, 5);
        
        // CRITICAL: Ensure exactly ONE placeholder per city
        const placeholderChefs = finalChefs.filter(chef => 
          chef.photo_url === PLACEHOLDER || 
          chef.photoUrl === PLACEHOLDER || 
          chef.imageUrl === PLACEHOLDER || 
          chef.image === PLACEHOLDER || 
          chef.img === PLACEHOLDER ||
          chef.isPlaceholder
        );
        
        // If we have more than one placeholder, replace extras with demo images
        let correctedChefs = finalChefs; // Default to finalChefs
        if (placeholderChefs.length > 1) {
          const nonPlaceholderDemo = demoChefs.filter(chef => !chef.isPlaceholder);
          let demoIndex = 0;
          
          // Keep the first placeholder, replace the rest
          let placeholderCount = 0;
          correctedChefs = finalChefs.map(chef => {
            const isPlaceholder = chef.photo_url === PLACEHOLDER || 
                                chef.photoUrl === PLACEHOLDER || 
                                chef.imageUrl === PLACEHOLDER || 
                                chef.image === PLACEHOLDER || 
                                chef.img === PLACEHOLDER ||
                                chef.isPlaceholder;
            
            if (isPlaceholder) {
              placeholderCount++;
              if (placeholderCount === 1) {
                // Keep the first placeholder
                return chef;
              } else {
                // Replace additional placeholders with demo images
                if (demoIndex < nonPlaceholderDemo.length) {
                  const demoChef = nonPlaceholderDemo[demoIndex++];
                  return {
                    ...chef,
                    photo_url: demoChef.img,
                    photoUrl: demoChef.img,
                    imageUrl: demoChef.img,
                    image: demoChef.img,
                    img: demoChef.img,
                    isPlaceholder: false,
                  };
                }
              }
            }
            return chef;
          });
          
          setChefs(correctedChefs);
        } else {
          setChefs(finalChefs);
        }
        
        // Store debug info
        const finalChefNames = (correctedChefs || finalChefs).map(c => c.name);
        console.log(`[${citySlug}] Final chefs displayed:`, finalChefNames);
        
        setDebugInfo({
          city: citySlug,
          realCount: realChefs.length,
          demoCount: mixedChefs.length - realChefs.length,
          totalCount: mixedChefs.length,
          realChefs: realChefs.map(c => c.name),
          demoChefs: demoChefs.slice(0, mixedChefs.length - realChefs.length).map(c => c.name),
          finalChefs: finalChefNames
        });
      } catch (error) {
        console.error(`[${citySlug}] Failed to fetch real chefs, falling back to demo data:`, error);
        console.error(`[${citySlug}] Error details:`, {
          name: error.name,
          message: error.message,
          stack: error.stack
        });
        // Fallback to demo data only
        const demoChefs = pickFiveForCity(citySlug).map((c, i) => {
          const img = c.img || PLACEHOLDER;
          const displayName = c.isPlaceholder ? c.name : `Chef ${c.name}`;

          return {
            id: `${citySlug}-demo-${i}`,
            name: displayName,
            city: cityLabel,
            data_source: 'demo',
            photo_url: img || PLACEHOLDER,
            photoUrl: img || PLACEHOLDER,
            imageUrl: img || PLACEHOLDER,
            image: img || PLACEHOLDER,
            img: img || PLACEHOLDER,
            isPlaceholder: c.isPlaceholder,
          };
        });
        setChefs(demoChefs);
        
        // Store debug info for fallback
        setDebugInfo({
          city: citySlug,
          realCount: 0,
          demoCount: demoChefs.length,
          totalCount: demoChefs.length,
          realChefs: [],
          demoChefs: demoChefs.map(c => c.name),
          error: 'API failed, using demo data only'
        });
      } finally {
        setLoading(false);
      }
    };

    loadChefs();
  }, [citySlug, cityLabel]);

  // We'll render "Meet the Chefs / CITY" with a slash separator.
  return (
    <section className="chef-grid-container" aria-labelledby="meet-chefs-city-title">
      <div className="chef-grid-header">
        <h2 id="meet-chefs-city-title" className="chef-grid-title">
          <span className="chef-title-text">Meet the Chefs</span>
          <span style={{ color: '#888', fontWeight: 300, margin: '0 4px' }} aria-hidden="true"> / </span>
          <span className="chef-city-wrapper">
            <span className="chef-grid-kicker" aria-hidden="true">CITY</span>
            <span className="chef-city-name">{cityLabel}</span>
          </span>
        </h2>
      </div>

      {/* API Status Banner */}
      {debugInfo && debugInfo.error && (
        <div className="api-status-banner demo-data-notice">
          <div className="banner-content">
            <span className="banner-icon">⚠️</span>
            <span className="banner-text">
              <strong>Demo Data Mode:</strong> Chef API is temporarily unavailable. 
              Showing sample chefs for {cityLabel}. Real chef data will return when the API is restored.
            </span>
          </div>
        </div>
      )}

      {/* Debug Panel */}
      {debugInfo && (
        <details className="debug-panel">
          <summary className="debug-summary">🔍 Debug Info (Click to expand)</summary>
          <div className="debug-content">
            <div className="debug-section">
              <h4>API Status</h4>
              <p><strong>City:</strong> {debugInfo.city}</p>
              <p><strong>Real Chefs:</strong> {debugInfo.realCount}</p>
              <p><strong>Demo Chefs:</strong> {debugInfo.demoCount}</p>
              <p><strong>Total:</strong> {debugInfo.totalCount}</p>
              {debugInfo.error && <p><strong>Error:</strong> {debugInfo.error}</p>}
            </div>
            <div className="debug-section">
              <h4>Chef Names</h4>
              <p><strong>Real:</strong> {debugInfo.realChefs.join(', ') || 'None'}</p>
              <p><strong>Demo:</strong> {debugInfo.demoChefs.join(', ') || 'None'}</p>
              <p><strong>Final Display:</strong> {debugInfo.finalChefs?.join(', ') || 'None'}</p>
            </div>
          </div>
        </details>
      )}

      <nav className="chef-city-nav" aria-label="Choose a city">
        {CITIES.map((c) => (
          <Link
            key={c.slug}
            to={`/chefs/${c.slug}`}
            className={`chef-city-link ${c.slug === citySlug ? "active" : ""}`}
          >
            {c.label}
          </Link>
        ))}
      </nav>

      {loading && <div className="help-text">Loading chefs…</div>}
      {!loading && <ChefGrid chefs={chefs} />}
      
      {/* Debug info panel - remove in production */}
      {debugInfo && (
        <div style={{ 
          marginTop: '20px', 
          padding: '15px', 
          backgroundColor: '#f8f9fa', 
          border: '1px solid #dee2e6', 
          borderRadius: '8px',
          fontSize: '14px'
        }}>
          <h4>🔍 Debug Info ({debugInfo.city})</h4>
          <p><strong>Real chefs:</strong> {debugInfo.realCount} | <strong>Demo chefs:</strong> {debugInfo.demoCount} | <strong>Total:</strong> {debugInfo.totalCount}</p>
          {debugInfo.realChefs.length > 0 && (
            <p><strong>Real:</strong> {debugInfo.realChefs.join(', ')}</p>
          )}
          {debugInfo.demoChefs.length > 0 && (
            <p><strong>Demo:</strong> {debugInfo.demoChefs.join(', ')}</p>
          )}
          {debugInfo.error && (
            <p style={{ color: 'red' }}><strong>Error:</strong> {debugInfo.error}</p>
          )}
        </div>
      )}
    </section>
  );
}
